/** Parses a CSS length such as `480px` or `0` into pixels. */
const parseCssPx = (value: string | undefined): number => {
    if (value == null || value === '') {
        return Number.NaN;
    }
    const n = parseFloat(String(value).replace(/px$/i, '').trim());
    return Number.isFinite(n) ? n : Number.NaN;
};

export default parseCssPx;
